import type { EnrichedScenario } from '../model/types'

import { filter } from 'lodash/fp'
import { useTranslation } from 'react-i18next'

import { Button } from '@/shared/components/ui/button'
import { Header } from '@/shared/components/ui/layout'
import { ampli } from '@/shared/lib/ampli'
import { useModals } from '@/shared/lib/modal-manager'

import { useScenarios } from './ScenariosProvider'

export const ScenariosHeader = () => {
	const { t } = useTranslation()

	const { showModal } = useModals()
	const { selectedScenarioIds, scenarios, setSelectedScenarioIds } =
		useScenarios()
	const handleRunScenarios = () => {
		ampli.whatIfCompareClicked({
			whatif_compare_type: 'scenarios',
		})
		showModal('SCENARIOS_COMPARE', {
			scenarios:
				(filter(({ id }) => selectedScenarioIds.includes(id))(
					scenarios
				) as EnrichedScenario[]) || [],
		})
		setSelectedScenarioIds([])
	}

	return (
		<Header className='items-center justify-between border-b px-4 py-2'>
			<h3>{t('scenarios')}</h3>
			<Button
				variant='primary'
				onClick={handleRunScenarios}
				disabled={!selectedScenarioIds.length}
			>
				{t('scenario.run_scenarios')}
				{!!selectedScenarioIds.length && (
					<span>({selectedScenarioIds.length})</span>
				)}
			</Button>
		</Header>
	)
}
